// @flow
import { connect } from 'react-redux';

import { closeToast } from 'Store/toast/toast.actions';
import { Toast } from './Toast.jsx';

type ContainerProps = {
  color: string,
  icon: string,
  label: string,
  visible: boolean,
};

export function mapStateToProps(state: ReduxState = {}): ContainerProps {
  const { shouldDisplay, label, icon, color } = state.toast || {};

  return {
    visible: shouldDisplay,
    label,
    icon,
    color,
  };
}

const mapDispatchToProps = {
  onClose: closeToast,
};

export const ToastContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(Toast);
